import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateReminder($id: String!, $data: updateReminderInput!) {
    updateReminder(id: $id, data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateReminderRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateReminderInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'reminder/update_reminder',
  async (
  params: {id: String;data: TYPES.UpdateReminderInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateReminder;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateReminderSlice = createSlice({
  name: 'update_reminder',
  initialState: initialState,
  reducers: {
    updateReminderClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateReminderRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateReminderRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateReminderRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateReminderClear } = updateReminderSlice.actions;

export const updateReminder = createSelector(
  (state: RootState) => state.reminder.updateReminder.result,
  (state: RootState) => state.reminder.updateReminder.error,
  (state: RootState) => state.reminder.updateReminder.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateReminderSlice.reducer;